export default __webpack_public_path__ + "static/media/DisneyMarvelAvengers.b45d2b8e.jpg";